<template lang="pug">
section.control-year.filter-by-years.isMap.control-panel-box
  .asu-title.div-aux-to-fixed-header
    span.asu-title Línea de tiempo
  div.years-controls
    div.years-labels
      template(v-for="(year, index) in years")
        span {{year}}
        span(v-if="(index + 1) < years.length")
    div
      template(v-for="(year, index) in years")
        i.clickable(:class="'ap-timeline' + (filter.year === year ? '-selected':'')" @click="setYearAndStopEventPropagations($event, year)")
        .timeline-separator(v-if="(index + 1) < years.length")
    .separator
    .legends(:class="('year-' + years.findIndex(val => val === filter.year)) + ' ' + (showYearLengends ? 'show-legends':'')")
      span.asu-titles Cantidad de proyectos por fases
      div
        i.ap-planification-phase
          span {{data.count.planification}}
        i.ap-execution-phase
          span {{data.count.execution}}
        i.ap-finished-phase
          span {{data.count.finished}}
      div
        span.phase Planificación
        span.phase Ejecución
        span.phase Cierre

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { projectDefaultYear } from '@/constants.js'

const years = [ 2016, projectDefaultYear, projectDefaultYear + 2, 2030 ]

export default {
  name: 'ControlYear',
  data: () => ({
    years
  }),
  methods: {
    ...mapActions([
      'setYear',
      'toggle'
    ]),
    setYearAndStopEventPropagations (event, year) {
      this.setYear(year)
      event.stopPropagation()
    }
  },
  computed: {
    ...mapGetters({
      data: 'data',
      filter: 'projectsFilter',
      showYearLengends: 'showYearLengends'
    })
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$filter-year-pointer-size = $f45px
$filter-year-pointer-color = white
$filter-year-pointer-arrow-size = $f10px

$filter-year-pointer-in-map-size = $f35px
$filter-year-pointer-in-map-color = #0d2563
$filter-year-pointer-in-map-separator = "calc(%s + 17px)" % $filter-year-pointer-in-map-size

.isMobile
  .filter-by-years
    transform: scale(0.7)
  .legends
    display: none
  .show-legends
    display: block

.filter-by-years
  user-select none
  text-align: center
  color: $filter-year-pointer-in-map-color
  background-color: white
  border-radius: $f4px
  overflow-y: auto
  min-height: $f256px
  .asu-title
    padding-bottom: $f7px
    font-family: 'Roboto Condensed', Roboto
    display: flex
    align-items: center
    justify-content: space-between
    padding: 0 $title-padding 0 $title-padding
  span
    display inline-block
  .years-controls
    max-width: $f300px
  .years-labels span
    width: $filter-year-pointer-size
    font-size: 0.8rem
    font-weight: bold
  .clickable
    cursor: pointer
    display: inline-block
    font-size: $filter-year-pointer-size
    vertical-align: middle
  .timeline-separator
    display: inline-block
    width: $filter-year-pointer-size
    &:before,
    &:after
      content: ''
      background-color: $filter-year-pointer-color
      border-radius: 50%
      display: inline-block
      width: "calc(%s * .15)" % $filter-year-pointer-size
      height: "calc(%s * .15)" % $filter-year-pointer-size
    &:before
      margin-right: "calc(%s * .20)" % $filter-year-pointer-size
    &:after
      margin-left: "calc(%s * .20)" % $filter-year-pointer-size
.separator
  height: $filter-year-pointer-arrow-size
.legends
  border: .09375rem solid white
  border-radius: $f5px
  font-size: .9rem
  position: relative
  text-align: center
  div
    display: flex
    justify-content: space-between
    align-items: center
  i
    display inline-block
    font-size: 1.5rem
  span
    padding: 0 0 .1rem .3rem
  .phase, .asu-titles
    padding: .3rem
  .phase, i
    width: 4rem
  .phase
    font-size: .8rem
  &:before
    content: ''
    position: absolute
    bottom: 100%
    border-width: "calc(%s * 1.125)" % $filter-year-pointer-arrow-size
    border-style: outset
    border-color: transparent
    border-bottom: $filter-year-pointer-arrow-size solid white
  &.year-0:before
    left: "calc(5% - %s)" % ( $filter-year-pointer-arrow-size / 1.5)
  &.year-1:before
    left: "calc(34% - %s)" % ( $filter-year-pointer-arrow-size / 1.5)
  &.year-2:before
    left: "calc(63% - %s)" % ( $filter-year-pointer-arrow-size / 1.5)
  &.year-3:before
    left: "calc(92% - %s)" % ( $filter-year-pointer-arrow-size / 1.5)

.isMap
  .legends
    border: .09375rem solid $filter-year-pointer-in-map-color
    background-color: rgba(255,255,255, .8)
    &:before
      border-bottom: $filter-year-pointer-arrow-size solid $filter-year-pointer-in-map-color
    &.year-2016:before
      left: "calc(4% - %s)" % ( $filter-year-pointer-arrow-size / 1.5)
    &.year-2030:before
      left: "calc(93% - %s)" % ( $filter-year-pointer-arrow-size / 1.5)
  .years-labels span
    font-size: 1.2rem
    text-shadow: 0.0625rem 0.0625rem 0.3125rem #fff, -1px -1px 0.3125rem #fff
    width: "calc(%s + 7px)" % $filter-year-pointer-in-map-size
  .clickable
    font-size: $filter-year-pointer-in-map-size
    text-shadow: 0.0625rem 0.0625rem 0.3125rem #fff, -1px -1px 0.3125rem #fff
  .timeline-separator
    width: $filter-year-pointer-in-map-separator
    &:before,
    &:after
      background-color: $filter-year-pointer-in-map-color
      width: "calc(%s * .15)" % $filter-year-pointer-in-map-size
      height: "calc(%s * .15)" % $filter-year-pointer-in-map-size
    &:before
      margin-right: "calc(%s * .20)" % $filter-year-pointer-in-map-size
    &:after
      margin-left: "calc(%s * .20)" % $filter-year-pointer-in-map-size
.separator
  height: $filter-year-pointer-arrow-size
</style>
